import { Route, Routes } from "react-router";
import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import AdminRoute from "@/components/admin/AdminRoute";

// Lazy load pages for better performance
const Landing = lazy(() => import("./pages/Landing"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DirectorMessage = lazy(() => import("./pages/DirectorMessage"));
const Products = lazy(() => import("./pages/Products"));
const ProductCategory = lazy(() => import("./pages/ProductCategory"));
const Therapeutics = lazy(() => import("./pages/Therapeutics"));
const TherapyCategory = lazy(() => import("./pages/TherapyCategory"));
const Blogs = lazy(() => import("./pages/Blogs"));
const Divisions = lazy(() => import("./pages/Divisions"));
const Career = lazy(() => import("./pages/Career"));
const ContactPage = lazy(() => import("./pages/Contact"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminCMS = lazy(() => import("./pages/AdminCMS"));
const AdminProducts = lazy(() => import("./pages/AdminProducts"));
const AdminBlogs = lazy(() => import("./pages/AdminBlogs"));
const AdminBlogEditor = lazy(() => import("./pages/AdminBlogEditor"));
const ProductDetail = lazy(() => import("./pages/ProductDetail"));
const BlogCategory = lazy(() => import("./pages/BlogCategory"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const About = lazy(() => import("./pages/About"));

// Loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center space-y-4 p-4">
    <Skeleton className="h-12 w-12 rounded-full" />
    <Skeleton className="h-4 w-[200px]" />
  </div>
);

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/dir-mes" element={<DirectorMessage />} />
        <Route path="/prod" element={<Products />} />
        <Route path="/prod/:category" element={<ProductCategory />} />
        <Route path="/prod/:category/:productId" element={<ProductDetail />} />
        <Route path="/therapy" element={<Therapeutics />} />
        <Route path="/therapy/:category" element={<TherapyCategory />} />
        <Route path="/therapy/:category/:productId" element={<ProductDetail />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:category" element={<BlogCategory />} />
        <Route path="/blogs/:category/:slug" element={<BlogPost />} />
        <Route path="/divisions" element={<Divisions />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<ContactPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        <Route path="/admin/cms" element={<AdminRoute><AdminCMS /></AdminRoute>} />
        <Route path="/admin/cms/blogs" element={<AdminRoute><AdminBlogs /></AdminRoute>} />
        <Route path="/admin/cms/blogs/create" element={<AdminRoute><AdminBlogEditor /></AdminRoute>} />
        <Route path="/admin/cms/blogs/:id" element={<AdminRoute><AdminBlogEditor /></AdminRoute>} />
        <Route path="/admin/products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}